import React from 'react';

type ProgressBarProps = {
  percentage?: number;
};

function ProgressBar({ percentage }: ProgressBarProps) {
  const progressBarStyle = {
    width: `${percentage}%`,
  };
  return (
    <div className="h-1.5 w-full bg-gray-200 rounded-xl">
      <div
        className="relative h-1.5 bg-primary rounded-xl"
        style={progressBarStyle}
      />
    </div>
  );
}

ProgressBar.defaultProps = {
  percentage: 0,
};
export default ProgressBar;
